export function percentRender(value: any): string {
    return `${value}%`
}